import React from "react";
import TextFeild from "../../Components/CustomTextFeild/TextFeild";
import { MdOutlineErrorOutline } from "react-icons/md";
import { useTranslation } from "react-i18next";

const AddDetail = ({
  addDetail,
  isEditable,
  paymentFormula,
  handleChangeDetails,
  formulaDetails,
  error,
}) => {
  const { t } = useTranslation("admin");
  return (
    isEditable === true && (
      <>
        <div className="payment__formula_formrow">
          <div className="payment__formula_formcol">
            <TextFeild
              Name="min"
              Label={t("payments.min")}
              Required={false}
              Disabled={paymentFormula?.formula_details?.length === 0}
              Data={formulaDetails.min}
              Adroment={paymentFormula?.type === "by_shipment" ? t("payments.countUnit") : "$"}
              Handler={(e) => handleChangeDetails(e)}
            />
          </div>
          <div className="payment__formula_formcol">
            <TextFeild
              Label={t("payments.max")}
              Data={formulaDetails.max}
              Name="max"
              Required={false}
              Adroment={paymentFormula?.type === "by_shipment" ? t("payments.countUnit") : "$"}
              Handler={(e) => handleChangeDetails(e)}
            />
          </div>

          <button
            className="prodidentifier__desc_modalsave prodidentifier__formula_details"
            onClick={addDetail}
          >
           <span>{t("common:actions.add")} </span> +
          </button>
        </div>

        <div
          style={{ justifyContent: "start", padding: "0px" }}
          className={`assign__pickup_modalerrorwrap ${
            error && "assign__pickup_modalerrorwrapopen"
          }`}
        >
          <div className="assign__pickup_modalerrorbox">
            <span>
              <MdOutlineErrorOutline size={16} style={{ marginTop: "2px" }} />
            </span>
            {error}
          </div>
        </div>
      </>
    )
  );
};

export default AddDetail;
